// extracted by css-extract-rspack-plugin
export default {"root":"wfexTG","subheading":"CeC24d","questions":"AOPR9B"};